/**
 * /affiliate — migrated from public/js/affiliate.js.
 * 1. Schimba imaginea embed cand `select[name="embed_type"]` change + animatie fade-in.
 * 2. Click pe textarea[name="embed_code"] → select + copy clipboard.
 * 3. Sticky menu + bookmark scrollspy (shared).
 */
import { Resort } from '../core/resort.js';
import { initStickyBookmarks } from '../shared/sticky-bookmarks.js';

new Resort(() => {
    const embedSelect = $('select[name="embed_type"]') as HTMLSelectElement | null;
    embedSelect?.on('change', function (this: Element) {
        const sel = this as unknown as HTMLSelectElement;
        const afImg = $('.aff-img') as HTMLImageElement | null;
        if (afImg) {
            afImg.setAttribute('src', `/assets/${sel.value}`);
            afImg.classList.add('fade-in');
            afImg.addEventListener('animationend', function (this: Element, e: Event) {
                e.stopPropagation();
                this.classList.remove('fade-in');
            }, { once: true });
        }
        const ta = $('textarea[name="embed_code"]') as HTMLTextAreaElement | null;
        ta?.val(`<a href="https://${window.location.hostname}" target="_blank"><img src="https://${window.location.hostname}/assets/${sel.value}" alt="${window.location.hostname}"></a>`);
    });
    embedSelect?.trigger('change');

    ($('textarea[name="embed_code"]') as HTMLTextAreaElement | null)?.on('click', function (this: Element) {
        (this as unknown as HTMLTextAreaElement).select();
        (this as unknown as HTMLTextAreaElement).focus();
        document.execCommand('copy');
    });

    initStickyBookmarks();
});
